import React, { useEffect, useMemo, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import VodItem from "../../../../components/boards/post/vod/VodItem";
import { isMobile } from "react-device-detect";
import { Controller, Navigation, Pagination } from "swiper";
import PostLink from "components/boards/post/PostLink";
import PrintDate from "components/boards/common/PrintDate";
import { VideoImage } from "components/ImageHandle";
import { getXmlTagValue, gtag, numberCommaString, secondToTime } from "helpers";
import MoreButton from "components/MoreButton";
import { storeLaterViewVod } from "actions/post.action";
import NickNameBadge from "components/boards/post/feed/NickNameBadge";
import CatchItem from "components/boards/post/catch/CatchItem";
import Nickname from "../../../../components/contents/Nickname";
import { useDispatch } from "react-redux";
import HomePinSection from "./HomePinSection";

import { localStorageFactory } from "helpers";
import AdItem from "components/boards/post/ad/AdItem";
import { useAdvertise } from "components/hook/useAdvertise";
import MoAdItem from "components/boards/post/ad/mo/MoAdItem";
import { SUCCESS } from "constant/status";

const VodSection = ({
    loading,
    title = 'VOD',
    vods = [],
    onDestroyPin,
    sliderPerView = 4,
    is_enable_horizontal = false,
    onTabCange,
    catchstory_total
}) => {
    const dispatch = useDispatch();
    const prefBtnRef = useRef(null);
    const nextBtnRef = useRef(null);
    const [processedVods, setProcessedVods] = useState([]);

    const swiperSettings = {
        className: `vod-list ${sliderPerView === 3 ? 'play_list' : ''}`,
        slidesPerView: sliderPerView,
        modules: [Controller, Navigation,  Pagination],
        wrapperTag: "ul",
        initialSlide: 0,
        spaceBetween: 18,
        navigation: { // 네비게이션 적용, < >
            prevEl: prefBtnRef.current,
            nextEl: nextBtnRef.current,
        },
        pagination: { clickable: true, el: '.swiper-pagination', type: 'bullets' },
        onClick: (swiper, event) => {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    const handleSwiperMoveButton = (event) => {
        event.stopPropagation();

        dispatch({type: 'ICT_CLOSE_MODAL'});
        dispatch({type: 'LATER_CLOSE_MODAL'});
    }

    const handleMoveVodPage = (event) => {
        event.stopPropagation();

        gtag("home", "vod");

    }

    const inflowPaths = useMemo(() => {
        let lastFeild = "home";
        if (title !== 'VOD') {
            lastFeild = "user";
        }
        return ["separate", "station", "home", lastFeild];
    }, [title]);


    const {creative, hasAd, trackingEvents, status} = useAdvertise(is_enable_horizontal)

    useEffect(() => {
        if (!isMobile) {
            if (vods.length > 2 && status === SUCCESS && hasAd) {
                // 이미 `creative`가 추가되었는지 확인
                if (!processedVods.includes(creative)) {
                    // vods 배열을 가공하여 새로운 배열 생성
                    const updatedVods = [...vods.slice(0, 2), creative, ...vods.slice(2)];
                    setProcessedVods(updatedVods);
                }
            } else {
                setProcessedVods(vods);
            }
        }
    }, [status, vods, hasAd]);

    return (
        <>
        {!isMobile && vods.length > 0 && (
            // 2안
                is_enable_horizontal ? (
                    <div>
                        <h3 className="ic uVod" onClick={handleMoveVodPage}>
                            <a href={`${global.bj_id}/vods`} onClick={(event) => {
                                event.stopPropagation();
                                if (is_enable_horizontal) {
                                    // user vod
                                    localStorageFactory.setItem('homeEntryVod', "2");
                                } else {
                                    localStorageFactory.setItem('homeEntryVod', '1');
                                }
                            }}>
                                {title}
                            </a>
                        </h3>
                        <section className="user_vod_wrap catchType">
                            <Swiper
                                    {...swiperSettings}
                                >
                                    {vods.map((vod, index) => {
                                        // 원저작자 혹은, 업로더 내용 추가
                                        const copyright = global.bj_id !== vod.user_id ? {
                                            user_id: vod?.user_id,
                                            user_nick: vod?.user_nick,
                                        } : null;
                                        if (vod.ucc.file_type == "CATCH") {
                                            return (
                                                <SwiperSlide tag={"li"} className="catch-list" key={`home_vod_${index}`}>
                                                    <CatchItem
                                                        loading={loading}
                                                        vod={{
                                                            ...vod,
                                                            copyright,
                                                        }}
                                                        inflowPath={inflowPaths}
                                                        isPpvBj={!!vod?.ucc?.paid_ppv}
                                                        page="pc_vod"
                                                        showCatchInfo={false}
                                                        onDestroyPin={onDestroyPin}
                                                        location={"home"}
                                                        catchCreated={title !== 'VOD'}
                                                    />
                                                </SwiperSlide>
                                            );
                                        } else {
                                            return (<SwiperSlide tag={"li"} key={`home_vod_${index}`}>
                                                <VodItem
                                                    vod={{
                                                        ...vod,
                                                        copyright,
                                                    }}
                                                    inflowPath={inflowPaths}
                                                    isPpvBj={!!vod?.ucc?.paid_ppv}
                                                    moreButtonTop={sliderPerView === 3 ? 190 : 150}
                                                    onDestroyPin={onDestroyPin}
                                                    location={"home"}
                                                    pageCreated={title !== 'VOD'}
                                                />
                                            </SwiperSlide>);
                                        }
                                    })}
                                </Swiper>
                                <button type="button" ref={prefBtnRef} className="user-clip-prev" onClick={handleSwiperMoveButton}>이전
                                </button>
                                <button type="button" ref={nextBtnRef} className="user-clip-next" onClick={handleSwiperMoveButton}>다음
                                </button>
                        </section>
                    </div>
                ) : (
                    //1안
                    <>
                        <h3 className="ic play_list" onClick={handleMoveVodPage}>
                            <a href={`${global.bj_id}/vods`} onClick={(event) =>{
                                event.stopPropagation();
                                if (is_enable_horizontal) {
                                    // user vod
                                    localStorageFactory.setItem('homeEntryVod', "2");
                                } else {
                                    localStorageFactory.setItem('homeEntryVod', '1');
                                }
                            }}>
                                {title}
                            </a>
                        </h3>
                        <div className={`${title === "VOD" ? "play_list_wrap" : ""}`}>
                            <Swiper {...swiperSettings}>
                                {processedVods.map((vod, index) => {
                                    // 원저작자 혹은 업로더 내용 추가
                                    const copyright =
                                        global.bj_id !== vod.user_id
                                            ? {
                                                user_id: vod?.user_id,
                                                user_nick: vod?.user_nick,
                                            }
                                            : null;

                                    return (
                                        <React.Fragment key={`home_vod_${index}`}>
                                            {vod.advertiser ? (
                                                <SwiperSlide tag="li" key={`home_vod_ad_${index}`}>
                                                    <AdItem
                                                        src={vod.image_url}
                                                        advertiser={vod.advertiser}
                                                        title={vod.title}
                                                        profileSrc={vod.profile_image_url}
                                                        videoUrl={getXmlTagValue('MediaFiles', vod.vast)[0]?.value || ''}
                                                        adUrl={getXmlTagValue('ClickThrough', vod.vast)[0]?.value || ''}
                                                        trackingEvents={trackingEvents}
                                                        clickLogUrl={getXmlTagValue('ClickTracking', vod.vast)[0]?.value || ''}
                                                    />
                                                </SwiperSlide>
                                            ) : (
                                                <SwiperSlide tag="li" key={`home_vod_vodItem_${index}`}>
                                                    <VodItem
                                                        vod={{
                                                            ...vod,
                                                            copyright,
                                                        }}
                                                        inflowPath={inflowPaths}
                                                        isPpvBj={!!vod?.ucc?.paid_ppv}
                                                        moreButtonTop={sliderPerView === 3 ? 190 : 150}
                                                        onDestroyPin={onDestroyPin}
                                                        location="home"
                                                        pageCreated={title !== 'VOD'}
                                                    />
                                                </SwiperSlide>
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                            </Swiper>
                            <button type="button" ref={prefBtnRef} className="play_list-prev" onClick={handleSwiperMoveButton}>이전
                            </button>
                            <button type="button" ref={nextBtnRef} className="play_list-next" onClick={handleSwiperMoveButton}>다음
                            </button>
                        </div>
                    </>)

            )}

        {isMobile && vods.length > 0 && (
        <>
            <h2 className={`ic-vod`} onClick={handleMoveVodPage}>
                <a href={`${global.bj_id}/vods`} onClick={(event) => {
                    if (is_enable_horizontal) {
                        // user vod
                        localStorageFactory.setItem('homeEntryVod', "2");
                    } else {
                        localStorageFactory.setItem('homeEntryVod', '1');
                    }
                }}>
                    {title}
                </a>
            </h2>
                <section className="sct-vod">
                    {vods.map((vod, index) => {
                        if (index < 4) {
                            return (
                                <React.Fragment key={`home_vod_${index}`}>
                                    {/* VOD 뭉치 */}
                                    <div className="vod-box" key={`home_vodItem_${index}`}>
                                        <PostLink post={vod} inflowPaths={inflowPaths}>
                                            {/* 썸네일 영역 */}
                                            <span className="thum">
                                                <VideoImage vod={vod} />

                                                {vod?.ucc?.file_type !== "CATCH" && (
                                                    <span className="time">
                                                        {secondToTime(vod?.ucc.total_file_duration / 1000)}
                                                    </span>
                                                )}
                                                {vod?.file_type === "REVIEW" && (
                                                    <em className="ic-replay">다시보기</em>
                                                )}
                                                {vod?.ucc?.file_type === "CATCH" && (
                                                    <span className="ic_catch">catch</span>
                                                )}
                                                {!!vod?.ucc?.paid_ppv && <span className="ic_ppv">유료</span>}
                                                {/* VOD 고정 핀 영역 */}
                                                {vod?.is_vod_pin && (
                                                    <HomePinSection
                                                        pinItem={vod}
                                                        boardTypeName="VOD"
                                                        onDestroyPin={onDestroyPin}
                                                        location="home"
                                                        created={title !== 'VOD'}
                                                    />
                                                )}
                                            </span>
                                        </PostLink>

                                        {/* VOD 정보 영역 */}
                                        <div className="vod-info">
                                            <div className="info">
                                                {global.bj_id !== vod?.user_id && (
                                                    <Nickname item={vod} top={25}>
                                                        <div className="nick">{vod?.user_nick}</div>
                                                    </Nickname>
                                                )}

                                                {/* 뱃지 */}
                                                {vod?.badge && global.bj_id !== vod.user_id && ( // 작성한 사람이 본인이면 제외
                                                    <NickNameBadge badge={vod?.badge} />
                                                )}
                                            </div>
                                            <p className="title">
                                                <PostLink post={vod} inflowPaths={inflowPaths}>
                                                    {vod?.title_name}
                                                </PostLink>
                                            </p>
                                            <div className="info">
                                                <span className="views">
                                                    {`${numberCommaString(vod?.count?.read_cnt)}`}
                                                </span>
                                                <PrintDate
                                                    tag="span"
                                                    attributes={{ className: "date" }}
                                                    target={vod.reg_date}
                                                />
                                            </div>
                                        </div>
                                        
                                        {/* 더보기 버튼 */}
                                        {vod.ucc.file_type !== "CATCH" && (
                                            <MoreButton
                                                top={35}
                                                right={0}
                                                trigger={
                                                    <button type="button" className="btn-detail">
                                                        <span>상세정보</span>
                                                    </button>
                                                }
                                            >
                                                <button
                                                    type="button"
                                                    onClick={() => storeLaterViewVod(vod.title_no)}
                                                >
                                                    <span>나중에 보기</span>
                                                </button>
                                            </MoreButton>
                                        )}
                                    </div>
                                </React.Fragment>
                            );
                        }})}

                        {/* 광고 뭉치 (고정 VOD 가 있든 없든 4개 이상이면 4번째 VOD 밑에 노출됨) */}
                        {hasAd && vods.length > 3 && !is_enable_horizontal && (
                            <MoAdItem
                                src={creative.image_url}
                                advertiser={creative.advertiser}
                                title={creative.title}
                                profileSrc={creative.profile_image_url}
                                videoUrl={getXmlTagValue('MediaFiles', creative.vast)[0]?.value || ''}
                                adUrl={getXmlTagValue('ClickThrough', creative.vast)[0]?.value || ''}
                                trackingEvents={trackingEvents}
                                clickLogUrl={getXmlTagValue('ClickTracking', creative.vast)[0]?.value || ''}
                            />
                        )}
                    </section>
                </>
            )}
        </>
    );
}

export default VodSection;
